import ResizeObserver from 'resize-observer-polyfill';

export class OffsetHelperComponent {
  private static offsetComponentInstance: OffsetHelperComponent;
  private static offsetHelperSelector = '[data-offset-helper]';
  private static offsetTargetSelector = '[data-js-offset-target]';
  private static offsetSourceSelector = '[data-js-offset-source]';

  public static get instance(): OffsetHelperComponent {
    if (!OffsetHelperComponent.offsetComponentInstance) {
      OffsetHelperComponent.offsetComponentInstance = new OffsetHelperComponent();
    }

    return OffsetHelperComponent.offsetComponentInstance;
  }

  private static adjustOffset(offsetSourceElement: HTMLElement): void {
    const { offsetHelperSelector, offsetTargetSelector } = OffsetHelperComponent
    const offsetTargetElement = offsetSourceElement.closest(offsetHelperSelector).querySelector(offsetTargetSelector) as HTMLElement;

    if (!offsetTargetElement) { return; }

    offsetTargetElement.style.height = `${offsetSourceElement.offsetHeight}px`;
  }

  private static initOffsetSourceObserver(): void {
    const { offsetHelperSelector, offsetSourceSelector } = OffsetHelperComponent
    const offsetSourceElements = document.querySelectorAll(`${offsetHelperSelector} ${offsetSourceSelector}`);

    if (!offsetSourceElements.length) { return; }

    const observer = new ResizeObserver((resizeObserverEntries ) => {
      resizeObserverEntries.forEach((resizeObserverEntry) => {
        OffsetHelperComponent.adjustOffset(resizeObserverEntry.target as HTMLElement);
      });
    });

    offsetSourceElements.forEach((offsetSourceElement) => {
      observer.observe(offsetSourceElement);

      OffsetHelperComponent.adjustOffset(offsetSourceElement as HTMLElement);
    });
  }

  public init(): void {
    window.addEventListener('load', OffsetHelperComponent.initOffsetSourceObserver);
  }
}
